@if (showForm() && employee()) {
  <beautyapp-booking-service-form
    [employees]="employees()"
    [employee]="employee()!"
    [room]="room()"
    [initialData]="initialData()"
    [bookingId]="bookingId()"
    [userId]="userId()"
    [bookingStatus]="data.bookingStatus"
    [bookingDate]="data.bookingDate ?? null"
    [salaryReadonly]="isEmployee()"
    [viewOnly]="viewOnly()"
    (formValueChange)="onFormValueChange($event)"
    (formValidChange)="onFormValidChange($event)"
    (serviceChange)="onServiceChange($event)"
    (serviceProductsChange)="onServiceProductsChange($event)"
    (specServicesChange)="onSpecServicesChange($event)"
  />
} @else {
  <div class="flex justify-center items-center h-32">
    <nz-spin></nz-spin>
  </div>
}

<div *nzModalFooter class="flex">
  @if (!viewOnly() && showForm() && formValue() && formComponent && !formComponent.needChooseService()) {
    <div class="flex flex-1 justify-start gap-4">
      <div>
        <beautyapp-input
          label="{{ 'calendar.form.numberProcedures' | translate }}"
          placeholder="{{ 'calendar.form.numberProcedures' | translate }}"
          type="number"
          [ngModel]="formValue()?.quantity"
          (ngModelChange)="formComponent.form.patchValue({ quantity: $event })"
          size="large"
        ></beautyapp-input>
      </div>
    </div>
  }

  <div class="flex-1"></div>

  <div class="flex gap-2" style="padding-top: 25px">
    <button
      nz-button
      nzType="default"
      nzSize="large"
      (click)="cancel()"
    >
      {{ 'buttons.close' | translate }}
    </button>

    @if (!viewOnly() && showForm() && formComponent && !formComponent.needChooseService()) {
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        type="button"
        [nzLoading]="loading()"
        (click)="submit()"
      >
        {{ 'buttons.save' | translate }}
      </button>
    }
  </div>
</div>
